module.exports = __webpack_public_path__ + "img/4.96cb3f74.png";